export const BaseLinkTemplate = `{{{text}}}`;
